import React from 'react'
import { WImage, EditableTitle, EditableDescription } from '@components/atoms'
import styles from './TimelineCard.module.sass'

interface Props {
  item: {
    pk?: number | string
    key?: string
    intro?: string
    name?: string
    description?: string
    image?: string
    image2?: string
  }
  editMode?: boolean
  className?: string
}

const TimelineCard = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <div className={`${styles.layout}`}>
        <div className={`${styles.imageBox}`}>
          {!!item.image && (
            <WImage
              src={item.image}
              maxWidth={720}
              maxHeight={538}
              alt={item.image}
              title={item.image}
              className={styles.image1}
            />
          )}
          {!!item.image2 && (
            <WImage
              src={item.image2}
              maxWidth={223}
              maxHeight={318}
              alt={item.image2}
              title={item.image2}
              className={styles.image2}
            />
          )}
        </div>
        <div className={`${styles.main} ${!item.name ? styles['main--no-title'] : ''}`}>
          {!!item.name && (
            <EditableTitle
              title={item.name}
              variant="h3"
              className={styles.title}
              editMode={editMode}
            />
          )}

          <div className={styles.content}>
            {/* Only render intro here if there is a name */}
            {!!item.intro && !!item.name && (
              <EditableTitle
                title={item.intro}
                variant="h3"
                className={styles.intro}
                editMode={editMode}
              />
            )}
            {/* Only render description here if there is a name */}
            {!!item.description && !!item.name && (
              <EditableDescription
                description={item.description}
                className={styles.description}
                editMode={editMode}
              />
            )}
          </div>
          {/* If there is no name, render intro and description below navigation */}
          {!!item.intro && !item.name && (
            <>
              <EditableTitle
                title={item.intro}
                variant="h3"
                className={`${styles.intro} ${styles.introBelowNav}`}
                editMode={editMode}
              />
              {!!item.description && (
                <EditableDescription
                  description={item.description}
                  className={`${styles.description} ${styles.descriptionBelowIntro}`}
                  editMode={editMode}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default TimelineCard
